import Vue from 'vue';
import VueRouter from 'vue-router';

import store from "../store";

import {
    CHECK_AUTH
} from "../store/actions.type";

/**
 * Route Components
 */
import Home from "../views/Home";
import Season from "../views/Season";
import Screens from "../views/Screens";
import NotFound from "../views/NotFound";
import Settings from "../views/Settings";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                reroute: true,
                showbar: true,
                printable: true,
                title: "Home"
            }
        },
        {
            path: '/Season-Schedule/:schedule/:team?/:year?/:month?',
            alias: '/s/:schedule/:team?/:year?/:month?',
            name: 'season',
            component: Season,
            meta: {
                reroute: false,
                showbar: false,
                printable: true,
                title: "Season"
            }
        },
        {
            path: '/screens',
            name: 'screens',
            component: Screens,
            meta: {
                reroute: false,
                showbar: true,
                printable: true,
                title: "Screens"
            }
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings,
            meta: {
                reroute: true,
                showbar: true,
                title: "Planner"

            }
        },
        {
            path: '/:sport/:league',
            name: 'home_params',
            component: Home,
            meta: {
                reroute: true,
                showbar: true,
                printable: true,
                title: "Events"
            }
        },
        {
            path: '*',
            component: NotFound,
            meta: {
                reroute: true,
                showbar: true,
                title: "Error"
            }
        }
    ]
});

router.beforeEach((to, from, next) =>
    Promise.all([store.dispatch(CHECK_AUTH)]).then(next)
);

export default router;
